import React from 'react';
import CustomerHeader from './CustomerHeader';
import CustomerFooter from './CustomerFooter';

const CustomerLayout = ({ children }) => {
  return (
    <div className="h-screen bg-gray-100 dark:bg-gray-900 flex flex-col transition-colors duration-300">
      <CustomerHeader />
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
  );
};

export default CustomerLayout;